import {
  GET_BASIC_DETAILS,
  GET_BASIC_DETAILS_COUNTRIES,
  GET_BASIC_DETAILS_SUPPLIERS,
  GET_BASIC_DETAILS_SUPPLIERS_SUCCESS,
  GET_BASIC_DETAILS_SUPPLIERS_FAILURE,
  GET_BASIC_DETAILS_COUNTRIES_FAILURE,
  GET_BASIC_DETAILS_COUNTRIES_SUCCESS,
  GET_BASIC_DETAILS_FAILURE,
  GET_BASIC_DETAILS_SUCCESS,
  RESET_BASIC_DETAILS,
  GET_BASIC_DETAILS_CATAGORIES,
  GET_BASIC_DETAILS_CATAGORIES_SUCCESS,
  GET_BASIC_DETAILS_CATAGORIES_FAILURE,
  GET_BASIC_DETAILS_SALESREPLEAD,
  GET_BASIC_DETAILS_SALESREPLEAD_SUCCESS,
  GET_BASIC_DETAILS_SALESREPLEAD_FAILURE,
  CREATE_NEGOTIATION,
  CREATE_NEGOTIATION_SUCCESS,
  CREATE_NEGOTIATION_FAILURE,
  CREATE_NEW_SUPPLIER,
  CREATE_NEW_SUPPLIER_SUCCESS,
  CREATE_NEW_SUPPLIER_FAILURE,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER_FAILURE,
  CREATE_NEW_SALES_REP_LEAD,
  CREATE_NEW_SALES_REP_LEAD_SUCCESS,
  CREATE_NEW_SALES_REP_LEAD_FAILURE,
  DELETE_SALES_REP_LEAD,
  DELETE_SALES_REP_LEAD_SUCCESS,
  DELETE_SALES_REP_LEAD_FAILURE,
  GET_ENTRA_ID_USERS,
  GET_ENTRA_ID_USERS_SUCCESS,
  GET_ENTRA_ID_USERS_FAILURE
} from "../Action/actionTypes";

interface BasicDetailsState {
  basicDetailsData: {
    negotiationName: string;
    leadCountry: string;
    categoryName: string;
    categoryCode: string;
    cluster: string;
    negotiationTeam: string;
    od: string;
    suppliers: string;
    supplierLocation: string;
    salesRepLead: string;
    additionalSalesRep: string;
    negotiationDateMonth: string;
    negotiationDateYear: string;
    negotiationImplementationMonth: string;
    negotiationImplementationYear: string;
    validityPeriod: number;
    relevantSpend: number;
    comment: string;
  };
  countriesData: object[];
  catagoriesData: object[];
  suppliersData: object[];
  salesRepLeadData: object[];
  EntraUsers: object[];
  formState: {
    state: boolean;
    ID: string | null;
  };
  createSupplierData: {
    name: string;
    location: string;
    phoneNo: string;
  };
  isLoaded: boolean;
  loading: boolean;
  error: string;
}

const initialState = {
  basicDetailsData: {
    negotiationName: "",
    leadCountry: "",
    categoryName: "",
    categoryCode: "",
    cluster: "",
    negotiationTeam: "",
    od: "",
    suppliers: "",
    supplierLocation: "",
    salesRepLead: "",
    additionalSalesRep: "",
    negotiationDateMonth: "",
    negotiationDateYear: "",

    negotiationImplementationMonth: "",
    negotiationImplementationYear: "",

    validityPeriod: 0,
    relevantSpend: 0,
    comment: "",
  },
  countriesData: [],
  catagoriesData: [],
  suppliersData: [],
  salesRepLeadData: [],
  EntraUsers: [],
  formState: {
    state: false,
    ID: null,
  }, // CREATE or UPDATE
  createSupplierData: {
    name: "",
    location: "",
    phoneNo: "",
  },
  loading: false,
  isLoaded: false,
  error: "",
};

const BasicDetailsReducer = (
  state = initialState,
  action: any
): BasicDetailsState => {
  switch (action.type) {
    case GET_BASIC_DETAILS:
    case CREATE_NEGOTIATION:
    case CREATE_NEW_SUPPLIER:
    case DELETE_SUPPLIER:
    case CREATE_NEW_SALES_REP_LEAD:
    case DELETE_SALES_REP_LEAD:
      return {
        ...state,
        loading: true,
      };

    case GET_BASIC_DETAILS_SUCCESS:
      return {
        ...state,
        basicDetailsData: action.payload,
        loading: false,
      };

    case GET_BASIC_DETAILS_FAILURE:
    case CREATE_NEGOTIATION_FAILURE:
    case CREATE_NEW_SUPPLIER_FAILURE:
    case DELETE_SUPPLIER_FAILURE:
    case DELETE_SALES_REP_LEAD_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CREATE_NEGOTIATION_SUCCESS:
      return {
        ...state,
        formState: action.payload,
        loading: false,
      };

    case CREATE_NEW_SUPPLIER_SUCCESS:
      return {
        ...state,
        createSupplierData: action.payload,
        loading: false,
      };

    case DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        suppliersData: action.payload,
        loading: false,
      };


    //-------------------------------------------------------------

    case CREATE_NEW_SALES_REP_LEAD_SUCCESS:
    case DELETE_SALES_REP_LEAD_SUCCESS:
      return {
        ...state,
        salesRepLeadData: action.payload,
        loading: false,
      };

    case CREATE_NEW_SALES_REP_LEAD_FAILURE:
      return {
        ...state,
        error: action?.payload,
        salesRepLeadData: [],
        loading: false,
      };

    //-------------------------------------------------------------

    case GET_BASIC_DETAILS_COUNTRIES:
    case GET_ENTRA_ID_USERS:
    case GET_BASIC_DETAILS_SALESREPLEAD:
    case GET_BASIC_DETAILS_CATAGORIES:
    case GET_BASIC_DETAILS_SUPPLIERS:
      return {
        ...state,
        loading: true,
        isLoaded: true,
      };

    case GET_BASIC_DETAILS_COUNTRIES_SUCCESS: {
      let countriesOptionArr = action.payload.map((data: any) => {
        return {
          name: data.name,
          value: data.id,
        };
      });
      return {
        ...state,
        countriesData: countriesOptionArr,
        loading: false,
        isLoaded: false,
      };
    }

    case GET_BASIC_DETAILS_COUNTRIES_FAILURE:
    case GET_ENTRA_ID_USERS_FAILURE:
    case GET_BASIC_DETAILS_CATAGORIES_FAILURE:
    case GET_BASIC_DETAILS_SUPPLIERS_FAILURE:
    case GET_BASIC_DETAILS_SALESREPLEAD_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isLoaded: false,
      };

    case GET_ENTRA_ID_USERS_SUCCESS:
      return {
        ...state,
        EntraUsers: action.payload,
        loading: false,
        isLoaded: false,
      };

    case GET_BASIC_DETAILS_CATAGORIES_SUCCESS:
      {
        let catagoriesOptionArr = action.payload.map((data: any) => {
          return {
            name: data.name,
            value: data.id,
            categoryCode: data.categoryCode,
            cluster: data.cluster,
          };
        });
        return {
          ...state,
          catagoriesData: catagoriesOptionArr,
          loading: false,
          isLoaded: false,
        };
      }

    case GET_BASIC_DETAILS_SUPPLIERS_SUCCESS: {
      let suppliersOptionArr = action.payload.map((data: any) => {
        return {
          name: data.name,
          value: data.id,
          supplierLocation: data.supplierLocation,
          address: data.address,
          mobileNumber: data.mobileNumber
        };
      });
      return {
        ...state,
        suppliersData: suppliersOptionArr,
        loading: false,
        isLoaded: false,
      };
    }

    case GET_BASIC_DETAILS_SALESREPLEAD_SUCCESS:
      {
      let salesrepleadOptionArr = action.payload.map((data: any) => {
        return {
          name: data.name,
          value: data.id,
          emailAddress: data.emailAddress,
          mobileNumber: data.mobileNumber,
          supplierID: data.supplierID
        };
      });
      return {
        ...state,
        salesRepLeadData: salesrepleadOptionArr,
        loading: false,
        isLoaded: false,
      };
    }
    case RESET_BASIC_DETAILS:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default BasicDetailsReducer;
